import React, { useState } from "react";
import LayoutWrapper from "../layout/LayoutWrapper";
import Header from "../layout/Header";
import axios from "../../api/axios";

function ZoomTest() {
  const [topic, setTopic] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState(30);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const createMeeting = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const url = "/zoom/meetings";
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("oeson_auth")}`,
        },
      };
      const data = {
        topic,
        start_time: startTime,
        duration,
      }
      const res = await axios.post(url, data, config);
      setResponse(res.data.data);
    } catch (error) {
      console.error("Error creating meeting:", error);
      setResponse({ error: "Failed to create meeting" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayoutWrapper>
      <Header />
      <div style={{ padding: "20px" }}>
        <h2>Zoom Meeting Test</h2>
        <form onSubmit={createMeeting}>
          <div>
            <label>Topic: </label>
            <input
              type="text"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Start Time (ISO): </label>
            <input
              type="datetime-local"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              required
            />
          </div>

          <div>
            <label>Duration (mins): </label>
            <input
              type="number"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Creating..." : "Create Meeting"}
          </button>
        </form>

        {response && (
          <div style={{ marginTop: "20px" }}>
            <h3>Response</h3>
            <pre>{JSON.stringify(response, null, 2)}</pre>
          </div>
        )}
      </div>
    </LayoutWrapper>
  );
}

export default ZoomTest;
